import {
  Button,
  Paper,
  useTheme,
  Tooltip,
  Box,
  TooltipProps,
  Typography,
  styled,
  tooltipClasses,
  useMediaQuery,
  ClickAwayListener
} from '@mui/material';
import { useIfVerifiedUser } from 'hooks/useUserState_utils';
import { useState } from 'react';
import { Trans } from 'react-i18next';
import { useAuth } from 'react-oidc-context';
import { Link as RouterLink } from 'react-router-dom';

export const LightTooltip = styled(
  ({ className, ...props }: TooltipProps & { color?: 'black' }) => {
    const [open, setOpen] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    return (
      <ClickAwayListener onClickAway={() => isMobile && setOpen(false)}>
        <Tooltip
          {...props}
          classes={{ popper: className }}
          onMouseLeave={() => isMobile && setOpen(false)}
          onClick={() => isMobile && setOpen(!open)}
          {...(isMobile ? { open } : {})}
        />
      </ClickAwayListener>
    );
  }
)(({ theme, color }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: color === 'black' ? 'default' : theme.palette.common.white,
    color: color === 'black' ? 'default' : 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    maxWidth: 'unset'
  },
  [`& .${tooltipClasses.arrow}`]: {
    ':before': {
      backgroundColor:
        color === 'black' ? 'default' : theme.palette.common.white,
      boxShadow: theme.shadows[1]
    }
  }
}));
export const NeedMoreTooltip: React.FC<{
  customTitle?: string;
  customText?: string;
}> = ({ customText, customTitle }) => {
  const auth = useAuth();

  const { isAuthenticated } = useAuth();
  const verified = useIfVerifiedUser();

  return (
    <Paper
      sx={{
        maxWidth: '400px',
        margin: 'auto'
      }}
    >
      <Box sx={{ textAlign: 'center', p: { xs: 1, sm: 3 } }}>
        <Typography variant="h6">{customTitle ?? 'Need more?'}</Typography>
        {isAuthenticated ? (
          !verified ? (
            <Trans i18nKey="actionButtons.notVerified" />
          ) : null
        ) : (
          <>
            <Typography variant="body2" sx={{ mb: 2 }}>
              {customText ??
                `Create your own account to discover & download more information
                about our products.`}
            </Typography>
            <Button
              variant="outlined"
              sx={{ mr: 2 }}
              onClick={() =>
                auth.signinRedirect({
                  redirect_uri:
                    window.location.origin + window.location.pathname
                })
              }
            >
              <Trans i18nKey="auth.login" />
            </Button>
            <Button variant="contained" component={RouterLink} to="/register">
              <Trans i18nKey="auth.signup" context="promote" />
            </Button>
          </>
        )}
      </Box>
    </Paper>
  );
};
